import { Directive,forwardRef } from '@angular/core';
import { Validator,NG_VALIDATORS,AbstractControl } from '@angular/forms';
import { isNull } from 'util';
import{ userService } from '../services/api-rest.service';
import{MessageService} from '../services/message.service';

@Directive({
  selector: '[validarContrasenia]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: forwardRef(() => ValidarContraseniaDirective),
    multi: true
  }, userService, MessageService]

})
export class ValidarContraseniaDirective implements Validator{

  constructor( public userService:userService){}

  validate(control: AbstractControl) : {[key: string]: any} {
    console.log("Entre a validar")
    if(isNull(control)) return  {nomatch: false}
    if(isNull(control.value) || control.value.length < 9) return {nomatch: false}
    if(control.value != null ) return this.verificarContasenia.bind(control.value)
    return null
  }

  private verificarContasenia(dato:string){
    this.userService.verificarClaveAnterior(dato).subscribe(
      result=>{
        console.log("Respuestas  validacion-->", result)
        if(!isNull(result)){
          return null
        }else{
          return {nomatch: false}
        }
      }
    )
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/directive/validar-contrasenia.directive.ts